import { Flex } from 'antd';
import { FC, useEffect, useState } from 'react';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { ConditionView, Icon, StepControlPanel, Typography } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { usePaymentShortPolling } from '@/hooks/usePaymentShortPolling';

import { UserServicePaymentType } from '@/api/types';

import { localStorageController } from '../../../../../../../Cache';
import { PAY_01_REDIRECT_URI } from '../../lib/constants';

export interface ServicePaymentProps {
  allowedPaymentType: UserServicePaymentType;
  paymentShortPolling: Pick<
    ReturnType<typeof usePaymentShortPolling>,
    'isShortPollingInProgress' | 'onResetPollingData'
  >;
  finishedUserRequestStatus: boolean;
  beforeRedirectToGerc?: () => void;
}

export const Payment: FC<StepProps<ServicePaymentProps>> = ({
  allowedPaymentType,
  paymentShortPolling: { isShortPollingInProgress },
  finishedUserRequestStatus,
  beforeRedirectToGerc,
  next,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getRedirectUri = (): Nullable<string> => {
    const cachedData = localStorageController.cachedData;
    return cachedData?.[PAY_01_REDIRECT_URI]?.data;
  };

  const handlePayOnline = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const redirect_uri = getRedirectUri();

      if (redirect_uri) {
        beforeRedirectToGerc && beforeRedirectToGerc();

        window.open(redirect_uri, '_self');
        localStorageController.clearCachedEndpoint(PAY_01_REDIRECT_URI);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isShortPollingInProgress && allowedPaymentType === UserServicePaymentType.ONLINE) {
      handlePayOnline();
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    finishedUserRequestStatus && next();
  }, [finishedUserRequestStatus]);

  return (
    <>
      <FormBlock title="Оплата">
        <ConditionView if={!isLoading} else={<Loader centered />}>
          <ConditionView if={isShortPollingInProgress}>
            <Flex vertical gap={16}>
              <Icon name="process_waiting" color="graphite" width={40} height={40} />
              <Flex vertical gap={8}>
                <Typography variant="H3">Будь ласка, зачекайте</Typography>
                <Typography>
                  Очікуйте, поки завершиться оплата. <br />
                  Зазвичай це займає не більше 2 хвилин.
                </Typography>
              </Flex>
            </Flex>
          </ConditionView>
        </ConditionView>
      </FormBlock>

      <ConditionView
        if={allowedPaymentType !== UserServicePaymentType.ONLINE}
        else={
          <ConditionView if={isShortPollingInProgress}>
            <div className="step-control-panel" style={{ position: 'relative', height: '50px' }}>
              <Loader centered />
            </div>
          </ConditionView>
        }
      >
        <StepControlPanel next={next} />
      </ConditionView>
    </>
  );
};
